import React, { useEffect, useState } from 'react';
import './index.css';
import './Header.css';
import strs from './strings';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import logo from './imgs/continentalis-isotipo.png';
import { AddOutlined, ExitToApp, HelpOutline, HomeOutlined, MenuOutlined, NotificationsOutlined, PersonOutline, GavelOutlined, EmailOutlined, WorkOutline} from '@mui/icons-material';
import { Box, useMediaQuery } from '@mui/system';
import zIndex from '@mui/material/styles/zIndex';
import { Icon, IconButton, Tooltip, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './context';
import { LogoutPopup } from './Popups';

const lang = strs.en;
// const headerColor = '#2f49d1';
// const headerColor = '#2f49d1';
const headerColor = 'white'
const textColor = '#333';


export function NewHeader() {
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');	
	let isLargeScreen = useMediaQuery('screen and (min-width: 1630px)');
	let shortScreen = useMediaQuery('screen and (max-height: 600px)');
	const [isCollapsed, setIsCollapsed] = React.useState(false);
	const [isMediumCollapsed, setIsMediumCollapsed] = React.useState(true);
	const [isCollaspedMobile, setIsCollapsedMobile] = React.useState(true);
	const {logout} = useAuth(); 
	const navigate = useNavigate();

	async function handleLogout() {
		try {
			await logout();	
			navigate('/login');
		}
		catch {
			console.log("Failed to log out");
		}
		return true;
	}

		useEffect( () => {isLargeScreen && setIsMediumCollapsed(true)},
		[isLargeScreen, isMediumCollapsed]

		)

	if ((isLargeScreen && !isCollapsed) || (!isLargeScreen && !isMobilePortraitScreen && !isMediumCollapsed)) {
		return (
		<Box
			sx = {{
				position: 'fixed',
				zIndex: 10,
			}}
		>
			<Sidebar 
				width='260px'
				rootStyles={{
					backgroundColor: headerColor,
					minHeight: '100vh',
					width: 'auto',
					color: 'black',
				}}
			>
			  <Menu menuItemStyles={{
				  button: {
					  backgroundColor: headerColor,
					  opacity: 1,
					color: textColor,
				  },
			  }}
			>
				<Link 
					style={{
						backgroundColor: headerColor,
							'&.hover': {
								backgroundColor: 'red',
							}
					}}
				to='/' id='home' className='center-flex grow-and-shrink-slightly header__logo-title' onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
					<img className='header__logo' alt="logo" src={logo}/>
					<Typography color={textColor} fontSize={20} fontWeight={500} fontFamily={'Commissioner'} 
>{'Continentalis'}</Typography>
				</Link>
				<div className='center-flex' style={{backgroundColor: headerColor}}>
					<IconButton sx={{color: 'black'}} onClick={() => {
						if (isLargeScreen) {
							setIsCollapsed(!isCollapsed);
						}
						else if (!isLargeScreen && !isMobilePortraitScreen){
							setIsMediumCollapsed(!isMediumCollapsed);
						}
						else {
						}

					}}>
						<MenuOutlined />
					</IconButton>
				</div>
				<Box height={25} backgroundColor={headerColor} />
				<center>
					<Link to='/' className='center-flex grow-and-shrink-slightly header__logo-title' style={{}}>
					<img src='/dashboard.png' alt='dashboard link' width='180' className='grow-and-shrink-slightly' /> 
					</Link>
				</center>
				<Box height={25} backgroundColor={headerColor}/>
				<Box className='center-flex' backgroundColor={headerColor}>
					<Typography color={textColor} fontSize={14}>{lang.profileAndCases}</Typography>
				</Box>
				<Link className='p' to={'/'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
				<MenuItem icon={<HomeOutlined />}>
						{lang.myCases}
				</MenuItem>
				</Link>
				<Link className='p' to={'/available-procedures'}  onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
					<MenuItem icon={<AddOutlined />}>
						{lang.newCase}
					</MenuItem>
				</Link>

				<Link className='p' to={'/notifications'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
				<MenuItem icon={<NotificationsOutlined />}>
					{lang.notifications}
				</MenuItem>
				</Link>

				<Link className='p' to={'/documents'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
					<MenuItem icon={<WorkOutline />}>
						{lang.documents}
					</MenuItem>
					</Link>
				<Link className='p' to={'/profile'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
					<MenuItem icon={<PersonOutline />}>
						{lang.profile}
					</MenuItem>
				</Link>

				<Box height={50} backgroundColor={headerColor}/>

				<Box>
				<Box className='center-flex' backgroundColor={headerColor}>
					<Typography color={textColor} fontSize={14}>{lang.other}</Typography>
				</Box>

				<Link className='p' to={'/faq'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
					<MenuItem icon={<HelpOutline />}>{lang.faq}</MenuItem>
				</Link>

				<Link className='p' to={'/contact'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
					<MenuItem icon={<EmailOutlined />}>{lang.contact}</MenuItem>
				</Link>

				<Link className='p' to={'/legal'} onClick={() => !isLargeScreen && !isMobilePortraitScreen && setIsMediumCollapsed(true)}>
				<MenuItem icon={<GavelOutlined />}>
					{lang.legal}
				</MenuItem>
				</Link>

				<Box height={50} backgroundColor={headerColor}/>

				<Box>
				<Box className='center-flex' backgroundColor={headerColor}>
					<Typography color={textColor} fontSize={14}>{lang.logout}</Typography>
				</Box>


				<Link className='p' onClick={handleLogout}>
					<MenuItem icon={<ExitToApp />}>
						{lang.logout}
					</MenuItem>
				</Link>
				</Box>
				</Box>
			  </Menu>
			</Sidebar>
		</Box>
		)	
	}
	else if ( (!isLargeScreen && !isMobilePortraitScreen) || (isMobilePortraitScreen && !isCollaspedMobile) || (isLargeScreen && isCollapsed)) {	
		const fadeIn = isMobilePortraitScreen ? 'slide-in-top' : '';
		const menuHeight = isMobilePortraitScreen ? '50vh' : '100vh';
		const positioning = shortScreen ? 'absolute' : 'fixed';
		return (
		<Box
			sx = {{
				position: positioning,
				zIndex: 10,
			}}
		>
			<Sidebar className={fadeIn}
				width='75px'
				rootStyles={{
					backgroundColor: headerColor,
					minHeight: menuHeight,
				}}
			>
			  <Menu menuItemStyles={{
				  button: {
					  backgroundColor: headerColor,
					  opacity: 1,
					color: 'white',
				  },
			  }}
			>
				<Link 
					style={{
						backgroundColor: headerColor
					}}
				to='/' id='home' className='center-flex grow-and-shrink-slightly header__logo-title'>
					<img className='header__logo' alt="logo" src={logo}/>
				</Link>
				<div className='center-flex' style={{backgroundColor: headerColor}}>
			<IconButton sx={{color: 'black'}} onClick={() => {
				if (isMobilePortraitScreen) {
					setIsCollapsedMobile(!isCollaspedMobile);
				} 
				else if (!isLargeScreen && !isMobilePortraitScreen) {
					setIsMediumCollapsed(!isMediumCollapsed);
					setIsCollapsed(false);
				} 
				else {
					setIsCollapsed(!isCollapsed);
				}
			}}>
					<MenuOutlined />
				</IconButton>
				</div>
				<Box height={25} backgroundColor={headerColor}/>
				<Box className='center-flex' backgroundColor={headerColor}>
				</Box>
				<Tooltip title={lang.myCases} placement='right' arrow>
					<Link className='p' to={'/'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
					<MenuItem icon={<HomeOutlined />} style={{color: 'black'}}/>
					</Link>
				</Tooltip>

				<Tooltip title={lang.newCase} placement='right' arrow>
					<Link className='p' to={'/available-procedures'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
						<MenuItem icon={<AddOutlined />} style={{color: 'black'}} />
					</Link>
				</Tooltip>

				<Tooltip title={lang.notifications} placement='right' arrow>
					<Link className='p' to={'/notifications'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
					<MenuItem icon={<NotificationsOutlined />} style={{color: 'black'}}/>
					</Link>
				</Tooltip>


				<Tooltip title={lang.documents} placement='right' arrow>
					<Link className='p' to={'/documents'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
						<MenuItem icon={<WorkOutline />} style={{color: 'black'}}/>
					</Link>
				</Tooltip>
				
				<Tooltip title={lang.profile} placement='right' arrow>
					<Link className='p' to={'/profile'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
						<MenuItem icon={<PersonOutline />} style={{color: 'black'}}/>
					</Link>
				</Tooltip>

				<Box height={50} backgroundColor={headerColor}/>
				<Box>
				<Box className='center-flex' backgroundColor={headerColor}>
				</Box>

				<Tooltip title={lang.faq} placement='right' arrow>
					<Link className='p' to={'/faq'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
						<MenuItem icon={<HelpOutline />} style={{color: 'black'}}></MenuItem>
					</Link>
				</Tooltip>

				<Tooltip title={lang.contact} placement='right' arrow>
					<Link className='p' to={'/contact'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
						<MenuItem icon={<EmailOutlined />} style={{color: 'black'}}></MenuItem>
					</Link>
				</Tooltip>

				
				<Tooltip title={lang.legal} placement='right' arrow>
					<Link className='p' to={'/legal'} onClick={() => isMobilePortraitScreen && setIsCollapsedMobile(!isCollaspedMobile)}>
					<MenuItem icon={<GavelOutlined />} style={{color: 'black'}}/>
					</Link>
				</Tooltip>


				<Box height={50} backgroundColor={headerColor}/>
				<Tooltip title={lang.logout} placement='right' arrow>
					<Link className='p' to={'/'} onClick={handleLogout}>
						<MenuItem icon={<ExitToApp />} style={{color: 'black'}}/>
					</Link>
				</Tooltip>
				</Box>
			  </Menu>
			</Sidebar>
		</Box>

		);
	}
	//We're on a mobile screen in landscape mode
	else {
		return (
		<Box
			sx = {{
				position: 'fixed',
				zIndex: 10,
				marginLeft: '10px',
			}}
		>
			<Sidebar className='fade-in'
				width='75px'
				rootStyles={{
					backgroundColor: 'none',
					borderRadius: '15px !important',
				}}
			>
			  <Menu menuItemStyles={{
				  button: {
					  backgroundColor: 'none',
					  opacity: 1,
// 					color: 'white',
				  },
			  }}
			>
				<div className='center-flex' style={{backgroundColor: '#e8eef6', borderRadius: 15,}}>
				<IconButton sx={{color: 'black'}}onClick={() => setIsCollapsedMobile(!setIsCollapsedMobile)}>
					<MenuOutlined />
				</IconButton>
				</div>

			  </Menu>
			</Sidebar>
		</Box>


		);
	} 
}

